import $ from 'jquery';

/**
 * Custom Scripts
 */
 import slick from  './vendors/slider.min';
 import Form from './custom/forms';
 import SocialMedia from './custom/bjzm-social-feeds';
 import BjzmScripts from './custom/bjzm-scripts';
 import Slider from './custom/bjzm-slideshow.js';

 import BjzmLoadMorePosts from './custom/bjzm-load-more-posts';
 import HeaderScroll from './custom/header-scroll';
 import SinglePageUpdown from './custom/single-page-updown';
 // import AngelScroll from './custom/bjzm-magic-scroll';
 import BjzmFormScripts from './custom/bjzm-form-scripts';
 // import ParallaxGallery from './custom/parallax-gallery';

/**
 * Vendors
 */
 // import matchHeight from './vendors/jquery.matchHeight';
 // import magnificPopup from 'magnific-popup';




 jQuery(document).ready(function($) {

 	var ThemeScripts = new BjzmScripts();
 	var RegisterFormScripts = new BjzmFormScripts();


 	var nextArrow = '<div class="slick-next slick-arrow"><div class="chevron-arrow chevron-arrow-right"></div></div>';
 	var prevArrow = '<div class="slick-prev slick-arrow"><div class="chevron-arrow chevron-arrow-left"></div></div>';

 	$('.bjzm-gallery__list').slick({
 		centerMode: true,
 		dots: false,
 		centerPadding: '10px',
 		slidesToShow: 3,
 		variableWidth: true,
 		arrows: true,
 		prevArrow: prevArrow,
 		nextArrow: nextArrow,
 		infinate: false,
 	});




 	var subMenuScroll = new SinglePageUpdown({
 		container: $(".navigation"),
 		offset: 80,
 		callBack: function() {
 			ThemeScripts.closeMobileMenu()
 		}
 	});


 	/* Header Scroll */
 	var MainHeaderScroll = new HeaderScroll({
 		header: $(".header--collapse"),
 		threshold: 40,
 		class: 'header--collapsed',
 	});


 	/*privacy policy*/
 	

 });









